/* istanbul ignore file */
import { connect } from 'react-redux';
import { getRepositories } from 'state/callers';
import Processing from './Processing';

const mapStateToProps = state => {
  const { repositories, showLoader } = state;

  return {
    repositories,
    showLoader
  };
};

const mapDispatchToProps = {
  getRepositories
};

export default connect(mapStateToProps, mapDispatchToProps)(Processing);
